module.exports = __webpack_public_path__ + "img/ic_cover_asset.c015660f.png";